import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-general-terms',
  templateUrl: './general-terms.component.html',
  styleUrls: ['./general-terms.component.scss'],
})
export class GeneralTermsComponent implements AfterViewInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  hasScrolledToBottom = false;

  constructor(public dialogRef: MatDialogRef<GeneralTermsComponent>) { }

  ngAfterViewInit() {
    this.checkScroll();
  }
  close() {
    this.dialogRef.close();
  }
  onScroll(event: any) {
    const element = event.target;
    const scrollPosition = element.scrollTop + element.clientHeight;
    const threshold = element.scrollHeight - 10; // 10px buffer

    if (scrollPosition >= threshold) {
      this.hasScrolledToBottom = true;
    }
  }

  private checkScroll() {
    setTimeout(() => {
      const element = this.scrollContainer.nativeElement;
      if (element.scrollHeight <= element.clientHeight) {
        this.hasScrolledToBottom = true;
      }
    }, 100);
  }

  accept() {
    if (this.hasScrolledToBottom) {
      this.dialogRef.close(true);
    }
  }

  decline() {
    this.dialogRef.close(false);
  }
}
